import { ProductReviewsEvent } from 'src/types';

export const PRODUCT_REVIEWS_VISIBILITY_NAME = 'productReviews';

export interface ProductReviewsImpression extends ProductReviewsEvent {
  event: 'custom_event';
  event_category: 'Product reviews';
  event_action: 'Impression';
  event_label: 'not set';
}

export interface ProductReviewsReadReviews extends ProductReviewsEvent {
  event: 'custom_event';
  event_action: 'Read reviews click';
  event_category: 'Product reviews';
  event_label: 'not set';
}

export interface ProductReviewsExpandReadMore extends ProductReviewsEvent {
  event: 'custom_event';
  event_action: 'Expand review click';
  event_category: 'Product reviews';
  event_label: 'not set';
}

export interface ProductReviewsProductRatingSystem extends ProductReviewsEvent {
  event: 'custom_event';
  event_action: 'Product rating system click';
  event_category: 'Product reviews';
  event_label: 'not set';
}

export interface ProductReviewsNextPage extends ProductReviewsEvent {
  event: 'custom_event';
  event_action: 'Next page click';
  event_category: 'Product reviews';
  event_label: number;
}

export interface ProductReviewsPagination extends ProductReviewsEvent {
  event: 'custom_event';
  event_action: 'Pagination click';
  event_category: 'Product reviews';
  event_label: number;
}
